import { Tooltip, TooltipContent, TooltipTrigger } from 'component-library';

export const TooltipWidget = ({ ...delegated }) => {
  return <Tooltip {...delegated} />;
};

export const TooltipContentWidget = ({ ...delegated }) => {
  return <TooltipContent {...delegated} />;
};

export const TooltipTriggerWidget = ({ ...delegated }) => {
  return <TooltipTrigger {...delegated} />;
};
